import React from "react";

const Java_Inheritance = () => {
  return (
    <div>
      <h1>Java Inheritance</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Inheritance in Java.</p>
    </div>
  );
};

export default Java_Inheritance;
